/* Miayaa product card: image dots + add to bag. Works on every page,
   including cards that appear after filtering or sorting a collection. */
(function () {
  if (window.__miayaaCard) return;
  window.__miayaaCard = true;

  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* keep the image dots in step with swiping */
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.classList || !track.classList.contains('mxk-card__track')) return;
    var dots = track.parentElement.querySelectorAll('.mxk-card__dots button');
    if (!dots.length) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
  }, { capture: true, passive: true });

  document.addEventListener('click', function (e) {
    /* tap a dot to jump to that photo */
    var dot = e.target.closest('.mxk-card__dots button');
    if (dot) {
      var wrap = dot.parentElement;
      var index = Array.prototype.indexOf.call(wrap.children, dot);
      var track = wrap.parentElement.querySelector('.mxk-card__track');
      if (track) track.scrollTo({ left: index * track.clientWidth });
      return;
    }

    var btn = e.target.closest('[data-mxk-add]');
    if (!btn) return;
    e.preventDefault();
    addToBag(btn);
  });

  function addToBag(btn) {
    var textEl = btn.querySelector('.mxk-card__btn-text');
    var original = btn.dataset.label || (textEl ? textEl.textContent : '');
    btn.dataset.label = original;
    var id = parseInt(btn.dataset.mxkAdd, 10);

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    btn.classList.add('is-loading');
    if (textEl) textEl.textContent = 'Adding…';

    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'error');

        if (cart && typeof cart.renderContents === 'function') {
          var state = res.items ? Object.assign({}, res.items[0], { sections: res.sections }) : res;
          cart.classList.remove('is-empty');
          cart.renderContents(state);
          var inner = cart.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
        } else {
          window.location.href = rootUrl + 'cart';
          return;
        }

        /* let Dawn know the cart changed (updates cart page if open) */
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'miayaa-card', productVariantId: id, cartData: res });
        }

        btn.classList.add('is-added');
        if (textEl) textEl.textContent = 'Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (textEl) textEl.textContent = original;
        }, 1800);
      })
      .catch(function (err) {
        var msg = err && err.message && err.message.length < 40 ? err.message : 'Try again';
        if (textEl) textEl.textContent = msg;
        setTimeout(function () { if (textEl) textEl.textContent = original; }, 2200);
      })
      .finally(function () { btn.classList.remove('is-loading'); });
  }
})();